import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "../../features/userSlice";
import { useQueryClient } from "@tanstack/react-query";
import { UserRole } from "../../utils/consts";
import { useOktaAuth } from "@okta/okta-react";

const pagesForServicer = [
  {
    label: "Training",
    link: "/training",
  },
];

const pagesForApprover = [
  {
    label: "Training",
    link: "/training",
  },
  {
    label: "Credit",
    link: "/training/credit",
  },
  {
    label: "Standardized Training Name",
    link: "/training/trainingName",
  },
];

const pagesForAdmin = [
  {
    label: "Training",
    link: "/training",
  },
  {
    label: "Credit",
    link: "/training/credit",
  },
  {
    label: "Admin",
    subMenus: [
      {
        label: "User Maintenance",
        link: "/training/admin/user-maintenance",
      },
      {
        label: "Servicer Maintenance",
        link: "/training/admin/servicer-maintenance",
      },
    ]

  },
];

const subPagesForAdmin = [
  {
    label: "User Maintenance",
    link: "/training/admin/user-maintenance",
  },
  {
    label: "Servicer Maintenance",
    link: "/training/admin/servicer-maintenance",
  },
];

const Navbar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [anchorElAdmin, setAnchorElAdmin] = React.useState(null);

  const { userName, userRole } = useSelector((state) => state.user)

  const dispatch = useDispatch()

  const queryClient = useQueryClient()

  const { oktaAuth } = useOktaAuth();

  const navigate = useNavigate();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  }
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  }
  const handleOpenAdminMenu = (event) => {
    setAnchorElAdmin(event.currentTarget);
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  }

  const handleCloseAdminMenu = () => {
    setAnchorElAdmin(null);
  };

  const handleLogout = async () => {
    // closes session, alternative to signOut()

    //oktaAuth.signOut()
    const accessToken = await oktaAuth.tokenManager.get("accessToken");

    // revokes access token
    await oktaAuth.token.revoke(accessToken);
    await oktaAuth.session.close();
    // clears okta-token-storage from localStorage. Although documentation for
    // closeSession() says tokens are cleared in TokenManager, the actual browser
    // localstorage maintains the idToken. This clear() removes it
    oktaAuth.tokenManager.clear();

    // Reloads browser to show sign-in widget again
    // window.location.reload();
    navigate("/user-logout");
  };
  const logoutUser = () => {
    //dispatch(userLogout());
    handleLogout();
    queryClient.clear();
  };

  const renderAppBarMenu = (userRole) => {
    if (userRole === UserRole.ADMIN) {
      return pagesForAdmin;
    } else if (userRole === UserRole.APPROVER) {
      return pagesForApprover;
    } else if (
      userRole === UserRole.SERVICER ||
      userRole === UserRole.SERVICER_COORDINATOR
    ) {
      return pagesForServicer;
    } else {
      return [];
    }
  };

  return (
    <AppBar position="static" sx={{ marginBottom: "90px" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Avatar
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Seal_of_the_United_States_Department_of_Housing_and_Urban_Development.svg/800px-Seal_of_the_United_States_Department_of_Housing_and_Urban_Development.svg.png"
            alt="HUD logo"
          />
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {
                renderAppBarMenu(userRole).map((page) => {
                  if(page.subMenus){
                    return(
                        <Box key={page.label}>
                          <Button
                              id="basic-button"
                              aria-controls={Boolean(anchorElAdmin) ? 'basic-menu' : undefined}
                              aria-haspopup="true"
                              aria-expanded={Boolean(anchorElAdmin) ? 'true' : undefined}
                              onClick={handleOpenAdminMenu}
                          >
                            ADMIN
                          </Button>
                          <Menu
                              id="basic-menu"
                              anchorEl={anchorElAdmin}
                              open={Boolean(anchorElAdmin)}
                              onClose={handleCloseAdminMenu}
                              MenuListProps={{
                                'aria-labelledby': 'basic-button',
                              }}
                          >
                            {
                              page.subMenus.map(subMenu => (
                                  <Link to={subMenu.link} key={subMenu.label}>
                                    <MenuItem>{subMenu.label}</MenuItem>
                                  </Link>
                              ))
                            }
                          </Menu>
                        </Box>

                        // <MenuItem>
                        //     <Typography textAlign="center">{page.label}</Typography>
                        // </MenuItem>
                    )
                  }else{
                    return (
                        <Link to={page.link} key={page.label}>
                          <MenuItem>
                            <Typography textAlign="center">{page.label}</Typography>
                          </MenuItem>
                        </Link>
                    )
                  }
                })
              }
            </Menu>
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {renderAppBarMenu(userRole).map((page) =>
              page.label !== "Admin" ? (
                <Button
                  key={page.label}
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  <Link to={page.link}>{page.label}</Link>
                </Button>
              ) : (
                //Admin Menu
                <Box key={page.label + "_box"}>
                  <Button
                    key={page.label}
                    onClick={handleOpenAdminMenu}
                    sx={{ my: 2, color: "white", display: "block" }}
                  >
                    <Link to={""}>{page.label}</Link>
                  </Button>
                  <Menu
                    sx={{ mt: "45px" }}
                    id="menu-appbar"
                    anchorEl={anchorElAdmin}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorElAdmin)}
                    onClose={handleCloseAdminMenu}
                  >
                    {/*{subPagesForAdmin.map((menu) => (*/}
                    {/*  <Link to={menu.link} key={menu.label}>*/}
                    {/*    <MenuItem onClick={handleCloseUserMenu}>*/}
                    {/*      <Typography textAlign="center">*/}
                    {/*        {menu.label}*/}
                    {/*      </Typography>*/}
                    {/*    </MenuItem>*/}
                    {/*  </Link>*/}
                    {/*))}*/}
                  </Menu>
                </Box>
              )
            )}
          </Box>
          <Box sx={{ flexGrow: 0, mr: 2 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                {userName && <Avatar>{userName[0].toUpperCase()}</Avatar>}
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {renderAppBarMenu(userRole).map((menu) => (
                <Link to={menu.link} key={menu.label}>
                  <MenuItem onClick={handleCloseUserMenu}>
                    <Typography key={menu.label} textAlign="center">
                      {menu.label}
                    </Typography>
                  </MenuItem>
                </Link>
              ))}
              <Link to={""} onClick={() => logoutUser()} key="logout">
                <MenuItem>Logout</MenuItem>
              </Link>
            </Menu>
          </Box>
          {/*<Box>*/}
          {/*    <LightOrNightSwitch />*/}
          {/*</Box>*/}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Navbar;
